import Loading from '@/components/widgets/Loading'
import { useUser } from '@/components/widgets/UserProvider'
import React from 'react'

const RingsMenu = ({
  activeTab,
  onTabPress,
}: {
  activeTab: any
  onTabPress: any
}) => {
  const menuItems = [
    { id: 'simple', label: ['', 'Solitaire'],redirect:{main_category:'Rings',subcategory: 'Solitaire',karat:"10"} },
    { id: 'halo', label: ['', 'Halo'],redirect:{subcategory:'Halo',karat:"10"} },
    { id: 'secret', label: ['Secret', 'Halo'],redirect:{subcategory:'Hidden Halo',karat:"10"} },
    // { id: 'toi', label: ['Toi et', 'Moi'],redirect:{subcategory:'Toi-et-Moi'} },
    { id: 'trilogy', label: ['', 'Three Stone'],redirect:{subcategory:'Three Stone',karat:"10"} },
    { id: 'fine', label: ['', 'Bezel'],redirect:{subcategory:'Bezel',main_category:'Rings',karat:"10"} },
    { id: 'nature', label: ['Nature', 'Inspired'], redirect: { subcategory: 'Nature Inspired' ,karat:"10"} },
    {id:'Instock',label:['','Instock'],redirect:{subcategory:'Instock',main_category:'Rings',karat:"14"}},
    // { id: 'designer', label: ['Designer', 'Rings'],redirect:{subcategory:'Designer',main_category:'Rings'} },
  ]
  const { userPageLoading } = useUser()

  return userPageLoading ? (
    <Loading
      classes={
        'flex-grow flex relative max-h-screen sm:min-h-[55px] mt-[15px] bg-[rgba(128,128,128,0.3)] !text-white'
      }
    />
  ) : (
    <div className='w-full bg-black lg:mt-[40px] mt-[0px]'>
      {/* Container with desktop margins */}
      <div className='relative mx-0 switch:mx-8'>
        <nav className='relative h-12 flex items-center'>
          {/* Lines that extend beyond the margins */}
          <div className='absolute left-[-999px] right-[-999px] h-[0.5px] bg-white top-0 ' />
          <div className='absolute left-[-999px] right-[-999px] h-[0.5px] bg-white bottom-0 ' />

          {/* Scrollable container */}
          <div className='overflow-x-auto [&::-webkit-scrollbar]:hidden w-full'>
            <div className='flex h-full min-w-max items-center sm:justify-center'>
              {menuItems.map((item, index) => (
                <div
                  key={item.id}
                  onClick={() => onTabPress(item)}
                  className={`h-12 flex items-center justify-center cursor-pointer transition-colors  duration-500 ease-in-out
                    ${
                      index === 0
                        ? 'border-l switch:border-l-[0.5px] border-white'
                        : 'border-l-[0.5px] border-white'
                    }
                    ${
                      index === menuItems.length - 1
                        ? 'border-r switch:border-r-[0.5px] border-white'
                        : ''
                    }
                    ${activeTab.id === item.id ? 'bg-white' : ''}`}
                >
                  <span
                    className={`font-barlowExtraLight px-2 text-[12px] sm:text-[16px] md:text-[20px] sm:px-4 tracking-widest uppercase whitespace-nowrap
                    ${activeTab.id === item.id ? 'text-black' : 'text-white'}`}
                  >
                    {item.label[0]}{' '}
                    <span className='font-barlowMedium'>{item.label[1]}</span>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default RingsMenu
